var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('layout',[_c('div',{staticClass:"container mt-4 p-2"},[_c('ContentWP',{attrs:{"type":_vm.typePage,"slug":_vm.$route.params.slug}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }